<template>
  <div class="fa-icon" :style="styling">
    <FontAwesomeIcon :icon="faIcon" v-bind="faProps" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

interface Props {
  type?: string;
  icon?: string | IconDefinition;
  size?: string | number;
}

const props = defineProps<Props>();

const faIcon = computed(() => {
  if (typeof props.icon === 'object') {
    return props.icon;
  } else {
    return [props.type || 'fas', props.icon || 'info'];
  }
});

const faProps = computed(() => {
  const result: Record<string, unknown> = {};
  // Only include props that FontAwesomeIcon accepts
  return result;
});

const styling = computed(() => {
  const styles: Record<string, string> = {};

  if (props.size != null) {
    styles.fontSize = `${props.size}em`;
  }

  return styles;
});
</script>

<style lang="scss">
$margin-size: 0.4em;

.fa-icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;

  > svg {
    font-size: inherit !important;
  }

  &.positive {
    color: var(--yellow-green);
  }

  &.negative {
    color: var(--red);
  }

  &.mrg {
    margin: $margin-size;
  }

  &.mrg-t {
    margin-top: $margin-size;
  }

  &.mrg-r {
    margin-right: $margin-size;
  }

  &.mrg-b {
    margin-bottom: $margin-size;
  }

  &.mrg-l {
    margin-left: $margin-size;
  }
}
</style>
